import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { IDocument } from '../database/generic';

export interface ISwipe extends IDocument {
  swipeId?: string;
  fromUserId: string;
  toUserId: string;
  eventId: string;
  message: string;
  amount: number;
  // 1= ,2= ,3=
  status?: number;
}

@Injectable({
  providedIn: 'root'
})

export class FriendService {

  constructor(private afStore: AngularFirestore) { }

  addSwipe(fromUserId, toUserId, eventId, message, counter) {
    return this.afStore.collection<ISwipe>(`user/${fromUserId}/swipe`).add({
      fromUserId: fromUserId,
      toUserId: toUserId,
      eventId,
      message,
      amount: counter
    });
  }
}
